import { useState, useCallback, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import MultipleQuestions from './MultipleQuestions';
import RankingQuestion from './RankingQuestions';
import { useHistory } from 'react-router-dom';
import publicIp from 'react-public-ip';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';
import { submitMessage } from '../../language';
import { language } from '../../language';
import CustomConfirmAlert from '../../Components/CustomAlert/CustomConfirmAlert';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import axiosInterceptor from '../../services/axiosInterceptor';

import submitResponse from '../../services/submitResponse';

const survey_en = [
    {
        id: 1,
        text: 'TV/Movies',
        questions: [
            {
                title: 'Please List Up to 3 different genres',
                type: 'genre',
                number: 3,
                prompt: 'Please type a genre'
            },
            {
                title: 'Please List Any Number of Titles of your Favorite TV shows or Movies',
                type: 'movie_tv',
                number: 0,
                prompt: 'Please type a movie name'
            }
        ]
    },
    {
        id: 2,
        text: 'Books',
        questions: [
            {
                title: 'Please List Your Favorite Authors',
                type: 'book_author',
                number: 3,
                choices: ['Drama', 'Comedy', 'Action', 'Fantasy'],
                prompt: 'Please type a author name'
            },
            {
                title: 'Please List Your Favorite Book Series',
                type: 'book_series',
                number: 0,
                prompt: 'Please type a book series name'
            },
            {
                title: 'Please List Any Number of Titles of your Favorite Books',
                type: 'books',
                number: 0,
                choices: [
                    'Game of Thrones',
                    'The Flash',
                    'Gothan',
                    'Breaking Bad'
                ],
                prompt: 'Please type a book title'
            }
        ]
    },
    {
        id: 3,
        text: 'News(Paper/Online)',
        questions: [
            {
                title: 'Please List Your Favorite News Sources',
                type: 'news_tv',
                number: 3,
                prompt: 'Please type a source name'
            },
            {
                title: 'Please List Your Favorite Social Media News Account',
                type: 'news_account',
                number: 0,
                prompt: 'Please type an account name'
            },
            {
                title: 'Please List Journalists, Reporters & Writers',
                type: 'news_person',
                number: 0,
                prompt: 'Please type a name'
            }
        ]
    },
    {
        id: 4,
        text: 'News(TV/Broadcasts)',
        questions: [
            {
                title: 'Please List Your Favorite News Network',
                type: 'news_tv',
                number: 3,
                prompt: 'Please type a news network'
            },
            {
                title: 'Please List news anchors / programs',
                type: 'anchors',
                number: 0,
                prompt: 'Please type a news anchors'
            }
        ]
    },
    {
        id: 5,
        text: 'Social Media',
        questions: [
            {
                title: 'Please List Your Favorite Websites',
                type: 'social_media_websites',
                number: 3,
                prompt: 'Please type a website'
            }
        ]
    }
];

const survey_fr = [
    {
        id: 1,
        text: 'TV et Films',
        questions: [
            {
                title: 'Veuillez lister 3 genres différents',
                type: 'genre',
                number: 3,
                prompt: 'Veuillez saisir un genre'
            },
            {
                title: 'Veuillez lister les titres d’un nombre quelconque de vos émissions télévisées ou films favoris',
                type: 'movie_tv',
                number: 0,
                prompt: 'Veuillez saisir un nom de film'
            }
        ]
    },
    {
        id: 2,
        text: 'Livres',
        questions: [
            {
                title: 'Veuillez lister vos auteurs favoris',
                type: 'book_author',
                number: 3,
                choices: ['Drama', 'Comedy', 'Action', 'Fantasy'],
                prompt: 'Veuillez saisir un nom d’auteur'
            },
            {
                title: 'Veuillez lister vos séries de livres favorites',
                type: 'book_series',
                number: 0,
                prompt: 'Veuillez saisir un nom de série de livres'
            },
            {
                title: 'Veuillez lister les titres d’un nombre quelconque de vos livres favoris',
                type: 'books',
                number: 0,
                choices: [
                    'Game of Thrones',
                    'The Flash',
                    'Gothan',
                    'Breaking Bad'
                ],
                prompt: 'Veuillez saisir un titre de livre'
            }
        ]
    },
    {
        id: 3,
        text: 'Actualités (papier/en ligne)',
        questions: [
            {
                title: 'Veuillez lister vos sources d’actualités favorites',
                type: 'news_tv',
                number: 3,
                prompt: 'Veuillez saisir un nom de source d’actualités'
            },
            {
                title: 'Veuillez lister vos comptes d’actualités favoris sur les réseaux sociaux',
                type: 'news_account',
                number: 0,
                prompt: 'Veuillez saisir un nom'
            },
            {
                title: 'Veuillez lister des journalistes, reporteurs et écrivains',
                type: 'news_person',
                number: 0,
                prompt: 'Veuillez saisir un nom'
            }
        ]
    },
    {
        id: 4,
        text: 'Actualités (TV/émissions)',
        questions: [
            {
                title: 'Veuillez lister vos réseaux d’actualités favoris',
                type: 'news_tv',
                number: 3,
                prompt: 'Veuillez saisir un réseau d’actualités'
            },
            {
                title: 'Veuillez lister des présentateurs ou programmes d’actualité',
                type: 'anchors',
                number: 0,
                prompt: 'Veuillez saisir un présentateur d’actualités'
            }
        ]
    },
    {
        id: 5,
        text: 'Média social',
        questions: [
            {
                title: 'Veuillez lister vos sites web favoris',
                type: 'social_media_websites',
                number: 3,
                prompt: 'Veuillez saisir un site web'
            }
        ]
    }
];

const MediaDiet = () => {
    const [cards, setCards] = useState(
        language === 'fr' ? survey_fr : survey_en
    );
    const [page, setPage] = useState(0);
    const [answers, setAnswer] = useState({});
    const [ip, setIp] = useState(null);
    const [startTime, setStartTime] = useState(Date.now());
    const [disabled, setDisabled] = useState(false);
    const history = useHistory();
    const [requiredCategory, setRequiredCategory] = useState({});

    const intl = useIntl();
    const messages = defineMessages({
        ranking: {
            id: 'MediaDiet.rankingInstruction',
            defaultMessage:
                'Please rank your favorite type of media By Drag and Drop each options'
        },
        missingMessageTitle: {
            id: 'New1.missingMessageTitle',
            defaultMessage: 'You have missing questions'
        },
        notFinish1: {
            id: 'New1.notFinished1',
            defaultMessage: 'You have not finish the following questions: '
        },
        notFinish2: {
            id: 'New1.notFinished2',
            defaultMessage:
                'Click on Cancel to return and finish survey, click on OK to submit the survey'
        }
    });

    useEffect(() => {
        const setInitialStates = async () => {
            try {
                const ipv4 = (await publicIp.v4()) || '';
                setIp(ipv4);
            } catch (err) {}
            setStartTime(Date.now());
        };
        setInitialStates();
        const checkConsent = async () => {
            try {
                const response = await axiosInterceptor().get(
                    'incas/consentAccepted'
                );
                if (!response.data.consentAccepted) {
                    history.push('/consent');
                }
            } catch (e) {
                console.log(e);
                history.push('/consent');
            }
        };
        checkConsent();
    }, []);

    useEffect(() => {
        const state = {};
        for (let card of cards) {
            for (let q of card.questions) {
                state[q.type] = false;
            }
        }
        setRequiredCategory(state);
    }, [cards]);

    //

    const getPage = useCallback(() => {
        if (page === 0) {
            return (
                <RankingQuestion
                    options={cards}
                    setOptions={setCards}
                    title={intl.formatMessage(messages.ranking)}
                />
            );
        } else {
            const allQuestions = [];
            for (let i = 0; i < 5; i++) {
                allQuestions.push(
                    <MultipleQuestions
                        key={i}
                        question={cards[i]}
                        setOptions={setAnswer}
                        answer={answers}
                        required={requiredCategory}
                        setRequired={setRequiredCategory}
                        setDisabled={setDisabled}
                    />
                );
            }
            return allQuestions;
        }
    }, [page, cards, requiredCategory]);

    const prevButton = useCallback(() => {
        if (page !== 0) {
            return (
                <Button
                    className="w-100"
                    variant="outline-success"
                    onClick={() => setPage(page - 1)}
                >
                    <FormattedMessage
                        id="MediaDiet.previous"
                        defaultMessage="Previous"
                    />
                </Button>
            );
        }
    }, [page]);

    const nextButton = useCallback(() => {
        if (page < 1) {
            return (
                <Button
                    className="w-100"
                    variant="outline-success"
                    onClick={() => setPage(page + 1)}
                >
                    <FormattedMessage
                        id="MediaDiet.next"
                        defaultMessage="Next"
                    />
                </Button>
            );
        } else {
            return (
                <Button
                    className="w-100"
                    disabled={disabled}
                    variant="outline-success"
                    onClick={async () => {
                        setDisabled(true);
                        const typesToName = {};
                        for (let card of cards) {
                            for (let question of card.questions) {
                                typesToName[question.type] = card.text;
                            }
                        }
                        const missing = new Set();
                        for (let type in answers) {
                            if (!answers[type] || answers[type].length === 0) {
                                if (!missing.has(typesToName[type])) {
                                    missing.add(typesToName[type]);
                                }
                            }
                        }
                        const missingPromptArray = Array.from(missing);
                        const missingPrompt = missingPromptArray.join(',');

                        if (missingPromptArray.length > 0) {
                            confirmAlert({
                                closeOnEscape: false,
                                closeOnClickOutside: false,
                                customUI: ({ onClose }) => {
                                    return (
                                        <CustomConfirmAlert
                                            title={intl.formatMessage(
                                                messages.missingMessageTitle
                                            )}
                                            text={
                                                intl.formatMessage(
                                                    messages.notFinish1
                                                ) +
                                                missingPrompt +
                                                '. ' +
                                                intl.formatMessage(
                                                    messages.notFinish2
                                                )
                                            }
                                            onClose={onClose}
                                            onOkay={async () => {
                                                const ranking = cards.map(
                                                    (card) => card.text
                                                );
                                                await submitResponse(
                                                    {
                                                        ranking: ranking,
                                                        answers: answers
                                                    },
                                                    history,
                                                    'media_diet',
                                                    ip,
                                                    startTime,
                                                    intl.formatMessage(
                                                        submitMessage.submitted
                                                    ),
                                                    true
                                                );
                                                setDisabled(true);
                                            }}
                                        ></CustomConfirmAlert>
                                    );
                                }
                            });
                            return;
                        }

                        const ranking = cards.map((card) => card.text);
                        await submitResponse(
                            {
                                ranking: ranking,
                                answers: answers
                            },
                            history,
                            'media_diet',
                            ip,
                            startTime,
                            intl.formatMessage(submitMessage.submitted),
                            true
                        );
                    }}
                >
                    <FormattedMessage
                        id="MediaDiet.complete"
                        defaultMessage="Complete"
                    />
                </Button>
            );
        }
    }, [page, answers, disabled]);
    return (
        <Container>
            <Row></Row>
            <Row>
                <Col>{getPage()}</Col>
            </Row>
            <Row className="mt-4 mb-5">
                <Col xs={6} md={3} className="mr-auto">
                    {prevButton()}
                </Col>
                <Col xs={6} md={3} className="ml-auto">
                    {nextButton()}
                </Col>
            </Row>
        </Container>
    );
};

export default MediaDiet;
